import { render, staticRenderFns } from "./DesktopPaymentMethod.vue?vue&type=template&id=3c7b1233&scoped=true"
import script from "./DesktopPaymentMethod.vue?vue&type=script&lang=js"
export * from "./DesktopPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./DesktopPaymentMethod.vue?vue&type=style&index=0&id=3c7b1233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b1233",
  null
  
)

export default component.exports